module.exports = __webpack_public_path__ + "img/SklodowskaCurieMaria.669de194.jpg";